import { jsx, jsxs } from "react/jsx-runtime";
import { Tooltip } from "@flatfile/design-system";
import { useRef, useState, useEffect } from "react";
import { FetchStatus } from "../../../utils/buffer/types.js";
import { useTranslation } from "react-i18next";
import { ListContainer, ListInner, Option, Status } from "./Styles.js";
const LIST_TOOLTIP_ID = "list-tooltip";
const List = ({
  hasMore,
  focused,
  fetchStatus,
  options,
  selectItem,
  focusEditor,
  singleSelect,
  isNewRowCell
}) => {
  const listRef = useRef(null);
  const focusRef = useRef(null);
  const { t } = useTranslation();
  const [activeItem, setActiveItem] = useState(0);
  const handleKeyDown = (event) => {
    if (!focused)
      return;
    if (event.key === "ArrowDown") {
      event.preventDefault();
      const activeIdx = activeItem + 1 >= options.length ? activeItem : activeItem + 1;
      setActiveItem(activeIdx);
      scrollToActiveItem();
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      const activeIdx = activeItem - 1 < 0 ? 0 : activeItem - 1;
      setActiveItem(activeIdx);
      scrollToActiveItem();
    } else if (event.key === "Enter") {
      event.stopPropagation();
      if (!singleSelect) {
        selectItem(options[activeItem]);
      }
    } else {
      focusEditor();
    }
  };
  const handleOptionKeyDown = (event, option) => {
    if (event.key === "Enter" || event.key === "Tab") {
      selectItem(option);
    }
  };
  const scrollToActiveItem = () => {
    const item = focusRef.current;
    const list = listRef.current;
    if (item && list) {
      list.scrollTop = item.offsetTop - 40;
    }
  };
  const focusItem = () => {
    var _a;
    if (focused && fetchStatus !== FetchStatus.loading) {
      (_a = focusRef == null ? void 0 : focusRef.current) == null ? void 0 : _a.focus({ preventScroll: true });
    }
  };
  const resetFocus = () => {
    setActiveItem(0);
    focusItem();
  };
  useEffect(() => {
    focusItem();
  }, [activeItem]);
  useEffect(() => {
    if (options.length === 1) {
      resetFocus();
    }
  }, [options]);
  useEffect(() => {
    if (focused) {
      resetFocus();
    }
  }, [focused]);
  return /* @__PURE__ */ jsx(ListContainer, { ref: listRef, isNewRowCell, children: /* @__PURE__ */ jsxs(ListInner, { onKeyDown: handleKeyDown, children: [
    options.map((option, idx) => /* @__PURE__ */ jsx(
      Option,
      {
        ref: focused && idx === activeItem ? focusRef : null,
        tabIndex: 1,
        onKeyDown: (e) => handleOptionKeyDown(e, option),
        onClick: () => selectItem(option),
        "data-testid": `option-${option.label}`,
        "data-tooltip-content": option.description,
        "data-tooltip-id": LIST_TOOLTIP_ID,
        children: option.label
      },
      `${option.label}-${idx}`
    )),
    hasMore && /* @__PURE__ */ jsx(Status, { children: t("sheet.table.cells.enum.seeMore") }),
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        id: LIST_TOOLTIP_ID,
        place: "right",
        className: "tooltip table-tooltip",
        float: true
      },
      LIST_TOOLTIP_ID
    )
  ] }) });
};
export {
  List
};
